import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  dragStart(event) {
    console.log("Drag start triggered");
    console.log("Element:", event.currentTarget);
    console.log("Dataset:", event.currentTarget.dataset);
    
    event.dataTransfer.dropEffect = "copy";
    event.dataTransfer.setDragImage(event.currentTarget, 0, 0);
    
    // Store the product ID globally
    const productId = event.currentTarget.dataset.productId;
    console.log("Product ID from dataset:", productId);
    
    window.draggedProductId = productId;
    console.log("Set window.draggedProductId:", window.draggedProductId);
  }

  dragEnd() {
    console.log("Drag end triggered");
    console.log("Clearing window.draggedProductId");
    window.draggedProductId = null;
  }
} 